import { render } from "./RegisterBanner.vue?vue&type=template&id=a215de2a"
import script from "./RegisterBanner.vue?vue&type=script&lang=js"
export * from "./RegisterBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__